import { EmptyCircleIcon } from 'app/agriculture/icons';
import 'app/agriculture/routes/Devices/DeviceDetails/components/display/trailcam/TrailCamHistorySectionRow.scss';
import { TrailCamHistoryRowDisplaySkeleton } from 'app/agriculture/routes/Devices/DeviceDetails/components/display/trailcam/TrailCamHistoryRowDisplaySkeleton';

export function TrailCamHistorySectionRowSkeleton() {
    return (
        <div className="TrailCamHistorySectionRow">
            <EmptyCircleIcon className="TrailCamHistorySectionRow__icon" />
            <button className="TrailCamHistorySectionRow__button">
                <TrailCamHistoryRowDisplaySkeleton />
            </button>
        </div>
    );
}
